import { createFeatureSelector, createSelector } from '@ngrx/store';

import { GreenhouseModuleState } from '../models/greenhouse.model';

export const getGreenhouseModuleState =
  createFeatureSelector<GreenhouseModuleState>('greenhouseModule');

export const selectGreenhouseNoticeVisibility = createSelector(
  getGreenhouseModuleState,
  (state) => state.greenhouseNoticeVisible,
);
